module.exports = __webpack_public_path__ + "img/album17_25.fb23bdae.jpg";